<script setup lang="ts">
import { useField } from 'vee-validate';
import { watch } from 'vue';

const props = defineProps({
  name: { type: String, required: true },
  nameValue: { type: String, required: true },
  label: { type: String, required: true },
});

// today minus 6 months
const minDate = new Date();
minDate.setMonth(minDate.getMonth() - 6);

const { value } = useField<string>(props.name);
const { value: formValue } = useField<string>(props.nameValue);

watch(value, (newValue) => {
  if (newValue) {
    formValue.value = new Date(newValue).toISOString().split('T')[0];
  } else {
    formValue.value = '';
  }
});
</script>

<template>
  <VueDatePicker
    v-model="value"
    text-input
    hide-input-icon
    auto-apply 
    :clearable="false"
    :enable-time-picker="false"
    :min-date="minDate"
    :max-date="new Date()"
    format="dd MMM yyyy"
  >
    <template #dp-input="{ value }">
      <input type="text" :value="value" :id="name" />
      <label :for="name">{{ label }}</label>
    </template>
  </VueDatePicker>
</template>

<style>
.dp__theme_light {
  --dp-primary-color: #006272 !important;
  --dp-cell-border-radius: 100% !important;
  --dp-cell-size: 25px !important;
  --dp-cell-padding: 3px !important;
  --dp-button-height: 25px !important;
  --dp-month-year-row-height: 25px !important; 
}

.dp__theme_light button {
  padding: 5px !important;
}

.dp__month_year_wrap button {
  margin-top: 0px;
}

.dp__month_year_wrap {
  margin-top: 5px;
}

.dp__inner_nav:hover {
  background: none !important;
}
</style>
